import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagRepository {

  private readonly repoUrl: string = `${environment.apiUrl}/feature-flags`;

  constructor(private http: HttpClient) { }

  public getAll(): Observable<Array<string>> {
    return this.http.get<Array<string>>(this.repoUrl);
  }
}
